module.exports = __webpack_public_path__ + "img/cry_active.7e38f270.svg";